// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"dd96f0ae","513":"535b1f50","703":"4671d844","787":"579776da"}[chunkId] + ".chunk.js";
};